import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getStoredSubscriptionDataTypes } from "../../utils/subscriptionAccess";

const Error404 = () => {
   const navigate = useNavigate();

   useEffect(() => {
      const token = localStorage.getItem("usertoken");
      const userRole = JSON.parse(localStorage.getItem("user"))?.role;
      const NewUser = JSON.parse(localStorage.getItem("new_user"));
      const subscription_data_types = getStoredSubscriptionDataTypes();

      if (token) {
         if (["Admin", "Staff", "Tester"].includes(userRole)) {
            navigate("/dashboard");
         } else if (
            userRole === "Account Admin" ||
            userRole === "Data Uploader" ||
            userRole === "Standard User" ||
            userRole === "Account Admin & Data Uploader"
         ) {
            if (NewUser == 1 && subscription_data_types.length > 0) {
               const subscription = JSON.parse(localStorage.getItem("is_subscribed"));
               if(userRole != "Account Admin") {
                  navigate(subscription === 1 ? "/weekly-data" : "/subscriptionplan");
               } else {
                  navigate(subscription === 1 ? "/dashboard" : "/subscriptionplan");
               }
            } 
            // else {
            //    navigate("/weekly-data");
            // }
         } 
         else {
            navigate("/subscriptionplan");
         }
      } else {
         localStorage.clear();
         navigate("/");
      }
   }, [navigate]);


   const handleRedirect = () => {
      const token = localStorage.getItem("usertoken");
      const userRole = JSON.parse(localStorage.getItem("user"))?.role;
      // const NewUser = JSON.parse(localStorage.getItem("new_user"));

      if (token) {
         if (["Admin", "Staff", "Tester"].includes(userRole)) {
            navigate("/dashboard");
         } else if (
            userRole === "Account Admin" ||
            userRole === "Data Uploader" ||
            userRole === "Standard User" ||
            userRole === "Account Admin & Data Uploader"
         ) {
            const subscription = JSON.parse(localStorage.getItem("is_subscribed"));
            if (subscription == 1) {
               if (userRole === "Account Admin" || userRole === "Account Admin & Data Uploader") {
                  navigate("/dashboard");
               } else {
                  navigate(userRole == "Account Admin" ? "/dashboard" : "/weekly-data");
               }
            } else {
               navigate("/subscriptionplan");
            }
         } 
         else {
            navigate("/subscriptionplan");
         }
      }
   };

   return (
      <div className="authincation h-100">
         <div className="container h-100">
            <div className="row justify-content-center h-100 align-items-center">
               <div className="col-md-6">
                  <div className="error-page">
                     <div className="error-inner text-center">
                        <div className="dz-error" data-text="404">404</div>
                        <h4 className="error-head">
                           <i className="fa fa-exclamation-triangle text-warning"></i> The page you were looking for is not found!
                        </h4>
                        <div>
                           <button className="btn btn-secondary" onClick={() => handleRedirect()}>
                              BACK TO HOMEPAGE
                           </button>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
};

export default Error404;
